import React, { useEffect } from 'react'
import { Player, Controls } from '@lottiefiles/react-lottie-player';
import { useNavigate } from 'react-router-dom'

const SplashScreen = () => {

    const navigate = useNavigate();

    useEffect(() => {
        let timeout = setTimeout(() => {
            navigate("/login", { replace: true })
        }, 3000);
        return () => {
            clearTimeout(timeout);
        }
    }, [])


    return (
        <div className='flex items-center justify-center h-screen'>
            <Player src={process.env.PUBLIC_URL + "/assets/animation/loading.json"} background="rgba(0, 0, 0, 0)" speed="1" loop autoplay style={{ height: 300 }}>
                <Controls visible={false} />
            </Player>
        </div>
    )
}

export default SplashScreen